import { NotFound } from 'components/common/NotFound';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import FairTopListPage from './pages/FairTopListPage';

function FairTopFeature() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path}>
        <FairTopListPage />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
}

export default FairTopFeature;
